import React from 'react';
import classNames from 'classnames';
import ContentLoader from 'react-content-loader';
import { useMediaQuery } from 'react-responsive';
import goldRing from 'Assets/layout/profile/gold-ring.svg';
import topProBadge from 'Assets/layout/profile/top-pro-badge.svg';

import Triangle from './AlertVector.png';
import './UserAvatar.scss';

// TODO: create condition for when we waiting for image to load

export enum AvatarSize {
  NORMAL = 'normal',
  SMALL = 'small',
  CHAT = 'chat',
  MODAL = 'modal',
  STATS = 'stats',
  PRO_LIST = 'pro-list',
  SUCCESS_MODAL = 'success-modal'
}

interface UserAvatarProps {
  mugshot: string; // url of the image
  username?: string;
  size: AvatarSize;
  skeleton?: boolean; // Show skeleton loader
  mugshotVideo?: boolean;
  topPro?: boolean;
  warning?: boolean;
}

const UserAvatar = ({ mugshot, mugshotVideo = false, topPro, warning, username = '', size, skeleton = false }: UserAvatarProps) => {
  const avatarStyles = classNames(['user-avatar'], {
    'user-avatar--size-normal': size === AvatarSize.NORMAL,
    'user-avatar--size-small': size === AvatarSize.SMALL,
    'user-avatar--size-chat': size === AvatarSize.CHAT,
    'user-avatar--size-modal': size === AvatarSize.MODAL,
    'user-avatar--size-stats': size === AvatarSize.STATS,
    'user-avatar--size-pro-list': size === AvatarSize.PRO_LIST,
    'user-avatar--size-success-modal': size === AvatarSize.SUCCESS_MODAL
  });

  const desktopOrLarger = useMediaQuery(
    { minWidth: 1024 }
  );

  if (skeleton) {
    let avatarRadius;

    switch (size) {
      case AvatarSize.SMALL:
        avatarRadius = 16;
        break;
      default:
      case AvatarSize.NORMAL:
        avatarRadius = desktopOrLarger ? 32 : 20;
        break;
      case AvatarSize.CHAT:
        avatarRadius = 36;
        break;
    }

    return (
      <ContentLoader
        speed={2}
        width={avatarRadius * 2}
        viewBox={`0 0 ${avatarRadius * 2} ${avatarRadius * 2}`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <circle cx={avatarRadius} cy={avatarRadius} r={avatarRadius} />
      </ContentLoader>
    );
  }

  return (
  <div styleName={avatarStyles}>
    <picture styleName={classNames('user-avatar__picture', { 'user-avatar__picture-top-pro': topPro })}>
      <img styleName="user-avatar__img" src={mugshot} alt={`${username}`} />
      { topPro &&
        <>
          <img styleName="user-avatar__golden-ring" src={goldRing} alt="TopProRing" />
          <img styleName="user-avatar__top-pro-badge" src={topProBadge} alt="TopProBadge" />
        </>
      }
      { warning && <img styleName="alert" src={Triangle} alt="" /> }
    </picture>
  </div>
  );
};

export default UserAvatar;
